import { FileUpload } from "./multipart-upload.types";

export const UNKNOWN_ERROR = "Error";

export function friendlyErrorMessage(
  error?: FileUpload["error"],
  clientError?: FileUpload["clientError"]
): [string, "error" | "warning"] {
  const errorToCheck = error || clientError || "";
  if (/duplicate_checksum|Provided file is a duplicate of document: (\d+)/.test(errorToCheck)) {
    return ["Duplicate", "warning"];
  }
  if (errorToCheck === "encrypted_pdf") {
    return ["Encrypted PDF", "warning"];
  }
  if (errorToCheck === "empty_document") {
    return ["Empty document", "warning"];
  }
  if (errorToCheck === "unreadable_pdf") {
    return ["Corrupt PDF", "error"];
  }
  if (errorToCheck === "size_exceeded") {
    return ["Exceeds 2gb", "error"];
  }
  if (errorToCheck === "invalid_type") {
    return ["Unsupported file type", "error"];
  }
  if (errorToCheck === "unconvertible_file") {
    return ["Error converting to PDF", "error"];
  }
  // Prefer just showing the message over Error
  return [error || UNKNOWN_ERROR, "error"];
}
